const PlayCircleIconSVG = ({ className = "", disabled = false }) => {
  return (
    <svg
      width="60"
      height="60"
      viewBox="4 0 60 60"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="34" cy="30" r="30" fill="white" />
      </g>
      <path
        d="M46 31.0005L29.5 40.5268L29.5 21.4742L46 31.0005Z"
        fill={disabled ? "#e6e6e6" : "black"}
      />
    </svg>
  );
};

export default PlayCircleIconSVG;
